import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@lemonadetraining/web-ui";

interface MyModalProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  backgroundColor?: string;
  maxHeight?: string;
  maxWidth?: string;
  /**
   * The dialog's accessible name. A modal without one is announced as just
   * "dialog", which tells a screen reader user nothing about what has taken
   * over their screen. Optional so the callers that name themselves inside
   * their own content are not forced to move it, but every new caller should
   * pass it.
   */
  title?: string;
  /** Show the title visually. False keeps it for assistive technology only. */
  showTitle?: boolean;
}

const MyModal: React.FC<MyModalProps> = ({
  open,
  onClose,
  children,
  backgroundColor,
  maxHeight = "90vh",
  maxWidth = "95vw",
  title,
  showTitle = true,
}) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        className="overflow-y-auto p-6"
        style={{
          backgroundColor: backgroundColor || "transparent",
          maxHeight,
          maxWidth,
        }}
      >
        {title && (
          <DialogHeader className={showTitle ? undefined : "sr-only"}>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        )}
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default MyModal;
